import React from 'react';
import Table from 'react-bootstrap/Table';
import { HistoriquePrixProduit } from '../../../../../common/src/entities';
import { DateTime } from 'luxon';

interface DynamicTableProps {
    data: HistoriquePrixProduit[];
    title: string;
}
function formatDate(timestampISO) {
    const dateTime = DateTime.fromISO(timestampISO, { zone: 'utc' });
    return dateTime.toFormat('dd-MMM-yy (EEE)').replaceAll('.', '');
}

const DynamicTable: React.FC<DynamicTableProps> = ({ data, title }) => {
    return (
        <div>
            <p>{title}</p>
            <Table striped bordered hover>
                <thead>
                    <tr>
                        <th>Date de début</th>
                        <th>Prix de vente fournisseur $</th>
                    </tr>
                </thead>
                <tbody>
                    {data.map((row) => (
                        <tr key={row.id}>
                            <td>{formatDate(row.date_debut)}</td>
                            <td>{row.facturation?.prix_de_vente_fournisseur}</td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </div>
    );
};

export default DynamicTable;
